import createIcon from '../../createIcon';

/**
 * @component @name NextWeek
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNi41SDE2VjQuNUMxNiAzLjk1IDE1Ljc4IDMuNDUgMTUuNDEgMy4wOUMxNS4wNSAyLjcyIDE0LjU1IDIuNSAxNCAyLjVIMTBDOC45IDIuNSA4IDMuNCA4IDQuNVY2LjVINEMyLjkgNi41IDIgNy40IDIgOC41VjE5LjVDMiAyMC42IDIuOSAyMS41IDQgMjEuNUgyMEMyMS4xIDIxLjUgMjIgMjAuNiAyMiAxOS41VjguNUMyMiA3LjQgMjEuMSA2LjUgMjAgNi41Wk0xMCA0LjVIMTRWNi41SDEwVjQuNVpNMTEgMThMMTAgMTdMMTMgMTRMMTAgMTFMMTEgMTBMMTUgMTRMMTEgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NextWeek = createIcon('NextWeek', [
  [
    'path',
    {
      d: 'M20 6.5H16V4.5C16 3.95 15.78 3.45 15.41 3.09C15.05 2.72 14.55 2.5 14 2.5H10C8.9 2.5 8 3.4 8 4.5V6.5H4C2.9 6.5 2 7.4 2 8.5V19.5C2 20.6 2.9 21.5 4 21.5H20C21.1 21.5 22 20.6 22 19.5V8.5C22 7.4 21.1 6.5 20 6.5ZM10 4.5H14V6.5H10V4.5ZM11 18L10 17L13 14L10 11L11 10L15 14L11 18Z',
      key: 'x5urw9',
    },
  ],
]);

export default NextWeek;
